import { defineComponent as r, createBlock as l, openBlock as p, unref as a, mergeProps as c, withCtx as d, createElementVNode as n } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const s = /* @__PURE__ */ r({
  name: "IconEyeOpen",
  __name: "IconEyeOpen",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (u, e) => (p(), l(a(i), c(t, { "view-box": "0 0 24 24" }), {
      default: d(() => [...e[0] || (e[0] = [
        n("path", {
          "fill-rule": "evenodd",
          d: "M12 8.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5M9.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0",
          "clip-rule": "evenodd"
        }, null, -1),
        n("path", {
          "fill-rule": "evenodd",
          d: "M21.721 11.794a.746.746 0 0 1-.008.44c-.582 2.002-2.198 3.501-4.002 4.487-1.82.994-3.942 1.529-5.711 1.529-1.769 0-3.892-.535-5.711-1.53-1.805-.985-3.42-2.484-4.002-4.487a.746.746 0 0 1-.008-.439c.576-2.016 2.197-3.525 4.01-4.515 1.819-.994 3.942-1.529 5.71-1.529 1.77 0 3.893.535 5.712 1.53 1.813.99 3.434 2.498 4.01 4.514m-14.713 3.61C5.463 14.561 4.261 13.393 3.786 12c.476-1.392 1.678-2.56 3.222-3.403C8.62 7.715 10.498 7.25 12 7.25c1.502 0 3.38.465 4.992 1.346 1.544.843 2.746 2.01 3.222 3.403-.476 1.394-1.677 2.562-3.222 3.405-1.613.881-3.49 1.346-4.992 1.346-1.502 0-3.38-.465-4.992-1.346",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
